import { createSlice } from '@reduxjs/toolkit'
import CommonServices from '../../services/commonServices';

const initialState = {
  applications: []
};

const applicationsSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    applicationsLoaded(state, action) {
      state.applications = action.payload;
    }
  },
})

export const { applicationsLoaded } = applicationsSlice.actions;

export default applicationsSlice.reducer;

export const fetchApplications = () => async (dispatch) => {
  try {
    const respData = await CommonServices.getApplications();
    if (respData.success) {
      const applications = respData.responseObject.value.applications;
      if (applications) {
        const objectsArray = applications.map((item) => ({ value: item.id, label: item.displayName, code:item.code }));
        dispatch(applicationsLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

